import React from 'react';
import { LogoGrowegy } from '../../../assets/icons';

export const AuthBannerReactivateForBenefits = () => {
  return (
    <div className="auth-content">
      <div className="auth-content__title">
        <img src={LogoGrowegy} className="auth-content__logo" alt="Logo" />
        <div className="auth-content__name">Growegy</div>
      </div>
      <div className="auth-content__subtitle">
        Reactivate your Growegy account before the offer expires
      </div>
      <ul className="auth-content__list">
        <li className="list-item">
          <strong>Freshen up your credit profile with new tradeline reports!</strong> Net30 terms
          and monthly credit reporting to Experian and Equifax.
        </li>
        <li className="list-item">
          <strong>Access to our full all-in-one business suite</strong> — including the business
          plan builder, content AI, and task management tools.
        </li>
        <li className="list-item">
          <strong>Loyalty perks</strong> you previously earned but didn’t redeem will automatically
          activate after your first payment.
        </li>
        <li className="list-item">
          You’ll also <strong>retain your progress</strong> toward future benefits — no need to
          start over.
        </li>
      </ul>
      <div>
        This is a limited-time opportunity created specifically for select customers — and we’d love
        to have you back in the Growegy community.
      </div>
    </div>
  );
};
